import React, { useState } from 'react';
import PriceInformation from '../../price-information';
import { getSortedPrices } from 'src/components/price-list/sorting';
import PriceListHeader from './price-list-header';
import PriceListFooter from './price-list-footer';
import PriceListBody from './price-list-body';
import { IPriceListPanelProps } from './types';
import { getListPrices, getCommonListProps, getListLimits } from './utils';
import MissingShop from '../../missing-shop';
import {
  PriceDisplay,
  PriceDisplayEnum,
  SortOptionEnum,
} from 'src/components/price-list/types';
import { useAppContext } from '@prisjakt/ui-app-context';
import { H3Text } from '@prisjakt/ui/text/variants';
import { PricePanel } from './styles';

function splitPriceList(
  currentSorting: SortOptionEnum,
  priceDisplay: PriceDisplay
): boolean {
  switch (currentSorting) {
    default:
    case SortOptionEnum.PRICE:
      return priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING;
    case SortOptionEnum.RECOMMENDED:
    case SortOptionEnum.PRICEANDSTOCKSTATUS:
      return true;
  }
}

export const PriceListPanel: React.FC<IPriceListPanelProps> = props => {
  const { me, variantGroups, conditions } = props;
  const [showMorePrices, setShowMorePrices] = useState(false);
  const [showMoreUnfeaturedPrices, setShowUnfeaturedMorePrices] = useState(
    false
  );
  const { t } = useAppContext();
  const sortedPrices = getSortedPrices(
    props.priceDisplay,
    props.currentSorting,
    props.prices
  );

  const isGroupedList = splitPriceList(
    props.currentSorting,
    props.priceDisplay
  );

  const prices = getListPrices(
    sortedPrices,
    isGroupedList,
    props.currentSorting,
    props.priceDisplay
  );
  const commonListProps = getCommonListProps(props);
  const listLimits = getListLimits(prices, isGroupedList);

  return (
    <PricePanel>
      <PriceListHeader
        conditions={conditions}
        variantGroups={variantGroups}
        categoryId={props.category?.id}
      />
      {props.storeStatistics && (
        <PriceInformation storeStatistics={props.storeStatistics} />
      )}
      {me?.analyticsAccess?.stores && <MissingShop />}

      {sortedPrices && sortedPrices.length > 0 ? (
        <>
          <PriceListBody
            sortedPrices={prices.mainList}
            showMorePrices={showMorePrices}
            numberOfVisiblePrices={listLimits.mainListLimit}
            {...commonListProps}
          />
          <PriceListFooter
            showProductInformationTexts={props.showProductInformationTexts}
            sortedPrices={prices.mainList}
            showMorePrices={showMorePrices}
            numberOfVisiblePrices={listLimits.mainListLimit}
            setShowMorePrices={setShowMorePrices}
          />
          {isGroupedList &&
            prices.secondaryList &&
            prices.secondaryList.length > 0 && (
              <>
                <H3Text>{t('product', 'splitlist-other.title')}</H3Text>
                <PriceListBody
                  sortedPrices={prices.secondaryList}
                  showMorePrices={showMoreUnfeaturedPrices}
                  numberOfVisiblePrices={listLimits.secondaryListLimit}
                  {...commonListProps}
                />
                <PriceListFooter
                  showProductInformationTexts={
                    props.showProductInformationTexts
                  }
                  sortedPrices={prices.secondaryList}
                  showMorePrices={showMoreUnfeaturedPrices}
                  numberOfVisiblePrices={listLimits.secondaryListLimit}
                  setShowMorePrices={setShowUnfeaturedMorePrices}
                />
              </>
            )}
        </>
      ) : null}
    </PricePanel>
  );
};
